import sx, {SxProp} from '@fuegokit/react/sx'
import styled from 'styled-components'

export const StyledButton = styled.button<SxProp>`
  ${sx};
`
